import script from "./SocioTherapyCoachingDigitalSignatureForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SocioTherapyCoachingDigitalSignatureForm.vue?vue&type=script&setup=true&lang=js"

import "./SocioTherapyCoachingDigitalSignatureForm.vue?vue&type=style&index=0&id=20ecf728&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20ecf728"]])

export default __exports__